<template>
  <div class="map-search-button">
    <div
      @click="emits('open-modal')"
      class="map-search-button__wrapper"
    >
      <div class="map-search-button__container">
        <i class="i-search" />
        <div
          class="map-search-button__text"
          :class="{ 'map-search-button__text--service': !!formWrapper.form.value.fields.filters.service }"
        >
          {{ formWrapper.form.value.fields.filters.service?.name || 'Wybierz usługę lub warsztat' }}
        </div>
      </div>
      <i
        v-if="formWrapper.form.value.fields.filters.service"
        @click.stop="clearServiceFilter"
        class="i-close"
      />
    </div>

    <div class="map-search-button__filters">
      <div
        class="map-search-button__filter"
        @click="clearBrandFilter"
        v-if="formWrapper.form.value.fields.filters.brand"
      >
        <i class="i-close" />
        <div>{{ formWrapper.form.value.fields.filters.brand.name }}</div>
      </div>
    </div>
  </div>

</template>

<script
  setup
  lang="ts"
>
import { type IFormCreatorResponse } from '@/composables/useFormCreator';
import { type IMapSearchFormFields } from '@/pages/mapa/index.vue';

interface IProps {
  formWrapper: IFormCreatorResponse<IMapSearchFormFields>;
}

interface IEmits {
  (name: 'open-modal'): void;
}

const emits = defineEmits<IEmits>();
const props = defineProps<IProps>();


// methods 
const clearServiceFilter = () => {
  props.formWrapper.form.value.fields.filters.service = null;
};
const clearBrandFilter = () => {
  props.formWrapper.form.value.fields.filters.brand = null;
};
</script>

<style
  lang="scss"
  scoped
>
.map-search-button {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 700px;
  margin: 20px auto 0 auto;
  display: flex;
  flex-direction: column;
  gap: 10px 0;
  padding: 0 20px;

  &__wrapper {
    padding: 10px 14px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    height: 56px;
    border-radius: 10px;
    border: 1px solid $grey-3;
    background: $white;
    box-shadow: 2px 4px 20px 0px rgba(209, 216, 229, 0.20);

    &:hover {
      border-color: $black;
    }
  }

  &__container {
    display: flex;
    align-items: center;
    gap: 0 10px;
  }

  &__text {
    color: $grey-3;
    font-size: 16px;

    &--service {
      color: $black;
    }
  }

  &__filters {}

  &__filter {
    background: $white;
    box-shadow: 2px 4px 20px 0px rgba(209, 216, 229, 0.20);
    border-radius: 10px;
    border: 1px solid $grey-5;
    font-size: 16px;
    display: flex;
    align-items: center;
    height: 38px;
    padding: 0 10px;
    gap: 0 8px;
    width: fit-content;
    cursor: pointer;
  }
}
</style>